import React from 'react';
import { useSelector } from 'react-redux';
import { getPoSSselector } from '../../../../../../../../../redux/reducers/reducerSlices/POSmartSchedulerReducer';
import { sagaActions } from '../../../../../../../../../sagas/sagaActions';
import moment from 'moment-timezone';
import DrilldownTableSS from '../../../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import { getUserSelector } from '../../../../../../../../../redux/reducers/reducerSlices/UserReducer';

/**
 * Component to show the available window recommendation details
 * for a given row in the Compliance Report.
 * Rendered as a modal popup when user clicks "Yes" in the AvailableWindow column.
 * @param {object} props
 * @param {string} props.themeSelected - current theme ('light-mode' | 'dark-mode')
 * @param {object} props.availableWindowData - { IDDock, IDWarehouse, PoNumber, recommendationDetails }
 * @param {Array}  props.recommendationDetails - recommendation details from the main API response
 */
const AvailableWindowDetails = (props) => {
    const { themeSelected = 'light-mode', availableWindowData, recommendationDetails = [] } = props;
    const pOSS = useSelector(getPoSSselector);
    const { arrangeOrder, arrangeKey } = pOSS;
    const userObj = useSelector(getUserSelector);
    const { selectedWarehouse } = userObj;
    moment.tz.setDefault(selectedWarehouse?.TimeZone);

    const titleData = [
        { id: 'serial_num', name: 'S.No' },
        { id: 'Name', name: 'Warehouse Name' },
        { id: 'DockName', name: 'Dock Name' },
        { id: 'TimeSlotName', name: 'Time Slot' },
        { id: 'PoNumber', name: 'PO Number' },
        { id: 'ApptStartTime', name: 'Recommended Time' },
    ];

    const formatBodyData = (data) => {
        return data.map((el, index) => ({
            id: el.row_num || index,
            0: index + 1,
            1: el.Name || '-',
            2: el.DockName || '-',
            3: el.TimeSlotName || '-',
            4: el.PoNumber || '-',
            5: el.ApptStartTime ? moment.utc(el.ApptStartTime).format("MM/DD/YYYY HH:mm") : '-',
        }));
    };

    const getBodyData = () => {
        if (recommendationDetails && recommendationDetails.length) {
            return formatBodyData(recommendationDetails);
        }
        return [];
    };

    return (
        <div className='p-3' style={{ width: 'auto', height: 'auto', minWidth: '600px' }}>
            <div className='f-16 mb-2'>
                {`Available Window Details — PO# ${availableWindowData?.PoNumber || ''}`}
            </div>
            <div className='allApptsListContainer-ss mt-3'>
                <DrilldownTableSS
                    key={Math.random()}
                    themeSelected={themeSelected}
                    bodyData={getBodyData()}
                    titleData={titleData}
                    showCollapse={false}
                    showInput={false}
                    showSort={false}
                    hasCollapsableContent={false}
                    arrangeOrder={arrangeOrder}
                    arrangeKey={arrangeKey}
                    drillDownReport={recommendationDetails}
                    initiateDrillDownReport={false}
                    loaderArray={6}
                    sortingAction={sagaActions.SORT_SS_USER_TABLE}
                    subRoot={{ pathName: 'availableWindowDetails' }}
                    showUTCTime={false}
                />
            </div>
        </div>
    );
};

export default AvailableWindowDetails;